import { Tooltip } from "@mui/material";

import { useQueryParams } from "../../../../../../hooks/useQueryParams";
import Colors from "../../../../../global/Colors";

const ButtonCounter = ({ title, value, statusType, disabled, isActive }) => {
  const { filters, updateFilter } = useQueryParams();

  const handleClick = () => {
    if (disabled) {
      return;
    }

    // Get current selected values from URL
    const currentValue = filters.get(statusType) || filters.get(statusType + "__in");
    let selectedValues = currentValue ? currentValue.split(",").map((v) => v.trim()) : [];

    if (isActive) {
      // Remove this value from selection
      selectedValues = selectedValues.filter((value) => value !== title);
    } else {
      // Add this value to selection
      selectedValues.push(title);
    }

    // Update filter with new values
    if (selectedValues.length > 0) {
      // Use __in suffix for multiple selections, let useQueryParams handle the logic
      updateFilter(statusType, selectedValues);
    } else {
      // Clear filter if no values selected
      updateFilter(statusType, null);
    }
  };

  return (
    <Tooltip title={`${title} - ${value}`}>
      <button
        id="counter-btn"
        className="flex items-center justify-center w-full h-10 p-4 m-1 text-xs border rounded-full shadow-lg"
        type="button"
        disabled={disabled}
        style={{
          cursor: disabled ? "not-allowed" : "pointer",
          color: isActive ? Colors.white : Colors.blue[3],
          backgroundColor: isActive ? Colors.blue[3] : Colors.blue[2],
          borderColor: isActive ? Colors.blue[3] : Colors.blue[2],
        }}
        onClick={handleClick}
      >
        <div className="w-full font-medium text-center align-middle line-clamp-2 h-fit text-ellipsis">
          {title} - {value}
        </div>
      </button>
    </Tooltip>
  );
};

export default ButtonCounter;
